import { fetchAndSanitizeSchema } from '~/utils/rjsfValidator';

import { request } from './common';

function basePath() {
  return window.configs.API_HOST + '/api/';
}

export async function getDetails(orderId, withoutPassportPhoto = false, submittedOnly = true) {
  const response = await request(
    `${basePath()}traveller/tour-details/${orderId}?submitted_only=${submittedOnly}&without_passport_photo=${withoutPassportPhoto}`,
    { method: 'GET' },
  );

  if (response?.result?.travellers) {
    return response.result.travellers;
  }

  return [];
}

export async function getTravellerDetailRequirements(offerId) {
  return request(basePath() + `traveller/traveller-requirements/${offerId}`, {
    method: 'GET',
  });
}

export async function getTravellerDetailRequirementsSchema(offerId) {
  return fetchAndSanitizeSchema(basePath() + `traveller/traveller-requirements/${offerId}`);
}

export async function createOrUpdateTravellerDetailRequirements(offerId, data) {
  return request(basePath() + `traveller/traveller-requirements/${offerId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}
